import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';
import { IPaginateElements, IPagination } from '@/store/types/search.types';
import { IPaymentCard } from '@/features/cards/store/models/card.model';
import {
  IPeriodField,
  ISearch,
  ISearchField,
  ISelectField,
  TPeriodBasesType,
} from '@/ui-kit/table-filters/filters.type';

export type TAllCardsTypeFieldValue = 0 | 1 | -1;

export enum agentCardActionTypes {
  SEARCH_AGENT_CARDS = 'AGENT_CARD.SEARCH_AGENT_CARDS',
  SEARCH_AGENT_CARDS_SUCCESS = 'AGENT_CARD.SEARCH_AGENT_CARDS_SUCCESS',
  SEARCH_AGENT_CARDS_FAIL = 'AGENT_CARD.SEARCH_AGENT_CARDS_FAIL',
}

export interface ISearchAgentCardsAction extends IBaseAction {
  type: typeof agentCardActionTypes.SEARCH_AGENT_CARDS;
}

export interface ISearchAgentCardsSuccessAction extends IBaseAction {
  type: typeof agentCardActionTypes.SEARCH_AGENT_CARDS_SUCCESS;
  cards: IPaymentCard[];
  pagination: IPagination;
}

export interface ISearchAgentCardsFailAction extends IBaseAction {
  type: typeof agentCardActionTypes.SEARCH_AGENT_CARDS_FAIL;
  error: TAppError;
}

export type TAgentCardAction = ISearchAgentCardsAction | ISearchAgentCardsSuccessAction | ISearchAgentCardsFailAction;

export interface ICardAgentState extends IBaseState {
  paginateCards: IPaginateElements<IPaymentCard>;
  isLoadingRestrictions: boolean;
}

export interface IAllCardsFiltersFormFields {
  search?: ISearch;
  status?: number;
  type?: TAllCardsTypeFieldValue;
  createdDate?: {
    from: string;
    to: string;
    base: TPeriodBasesType;
  };
}

export type TAllCardsFiltersFields = {
  status: ISelectField;
  type: ISelectField;
  createdDate: IPeriodField;
  search: ISearchField;
};
